import { animation } from "./_animation";
import { drawer } from "./_drawer";
import { slide } from "./_slide";
import { timeline } from "./_timeline";
import { map } from "./_map";
// import { scrollTop } from "./_scrollTop";
import { load } from "./_load";
import { accordion } from "./_accordion";
import { tab } from "./_tab";
import { contact } from "./_contact";

animation();
drawer();
slide();
timeline();
map();
// scrollTop();
load();
accordion();
contact();
tab();